import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Dashboard from './Dashboard';
import LoadingSpinner from './LoadingSpinner';

const DefaultRoute: React.FC = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect after loading is complete and user is available
    if (!isLoading && user?.role === 'inventory_manager') {
      navigate('/inventory', { replace: true });
    }
  }, [user, navigate, isLoading]);

  // Show loading spinner while auth is loading
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" text="Loading dashboard..." />
      </div>
    );
  }

  // For inventory managers, show loading while redirecting
  if (user?.role === 'inventory_manager') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" text="Redirecting..." />
      </div>
    );
  }

  return <Dashboard />;
};

export default DefaultRoute;